// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__rKMvC","vkbtn":"Auth_vkbtn__1zAI9","logo":"Auth_logo__U-8ek","formWrapper":"Auth_formWrapper__yQfNY","form":"Auth_form__nFgkP"};